
export interface Sale {
  id: string;
  id_user_vendeur: string;
  somme_a_vendre: number;
  monaie_vente: string;
  taux_vendeur: number;
  id_pays_vendeur: number;
  id_transaction_vendeur: string | null;
  id_user_acheteur: string | null;
  somme_a_recevoir: number;
  monaie_achat: string;
  id_transaction_acheteur: string | null;
  taux_marchand: number;
  somme_marchand: number;
  status: SaleStatus;
  created_at: string;
  updated_at: string;
}

export type Currency = "XAF" | "CAD" | "USD" | "EUR";

// Pour les statistiques
export interface SaleStats {
  total_amount: number;
  total_sales: number;
  completed_count: number;
  completed_amount: number;
  pending_count: number;
  pending_amount: number;
  cancelled_count: number;
  cancelled_amount: number;
  failed_count: number;
  failed_amount: number;
  unique_sellers: number;
  unique_buyers: number;
}

export enum SaleStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export interface GetSalesResponse {
  sales: Sale[];
  total: number;
  skip: number;
  limit: number;
}

export interface ApiResponse<T> {
  statusCode: number;
  message: string;
  data: T;
}